import { useSelector } from 'react-redux';
import { toast } from 'sonner';

const useAgentDefineValidator = () => {
  const agent = useSelector(state => state.agent.data);
  const agentType = useSelector(state => state.agent?.data?.campaignData?.campaignType);
  const KAType = useSelector(state => state.agent?.smartReply?.smartReplyData?.type);

  const isDefineNextButtonDisabled = () => {
    if (agent.title === '') {
      toast.warning('Enter a name for this agent');
      return true;
    }

    if ((KAType === 'email' || KAType === 'whatsapp') && agentType === 'rag') {
      return false;
    }

    if (agent.domainConfig.type === 'fullDomain' && agent.domainConfig.domainId === '') {
      toast.warning('Pick a domain for the placement');
      return true;
    }

    if (agent.domainConfig.type === 'sectionOfDomain' && agent.domainConfig.paths.length === 0) {
      toast.warning('Add at least one path');
      return true;
    }

    if (agent.domainConfig.type === 'singlePage' && agent.domainConfig.paths.length === 0) {
      toast.warning('Add at least one page');
      return true;
    }

    if (
      agent.domainConfig.type === 'regexSectionOfDomain' &&
      agent.domainConfig.paths.length === 0
    ) {
      toast.warning('Add at least one regex pattern');
      return true;
    }

    return false;
  };

  return { isDefineNextButtonDisabled };
};

export default useAgentDefineValidator;
